import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'LgvABSPipe'
})
export class LgvABSPipe implements PipeTransform {

    constructor() { }

    /*
     * Uses absolue value
     */

    transform(num: number) {
        return Math.abs(num);
    }
}
